const formatters = new Map<string, Intl.NumberFormat>();

const numberFormat = (locale: string, decimals: number): Intl.NumberFormat => {
	const key = `${locale}|${decimals}`;
	let formatter = formatters.get(key);

	if (!formatter) {
		formatter = new Intl.NumberFormat(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
		formatters.set(key, formatter);
	}
	return formatter;
};

/**
 * Every dollar amount in the console is AI provider spend, in USD. The prefix
 * is spelled out because a bare `$` reads as local currency in CL, MX, CO and AR;
 * the non-breaking space keeps it on the amount's line.
 */
export const formatUsd = (value: number, locale: string, decimals: number): string =>
	`US$\u00A0${numberFormat(locale, decimals).format(value)}`;
